module.exports = {
  src: __webpack_public_path__ + "logo-eaep-2661216f9d5265d1e5f34411bc0f7e65.svg",
  width: 167,
  height: 74,
  bytes: 13501,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-eaep-2661216f9d5265d1e5f34411bc0f7e65.svg";
};